$(() => {
  const booleanButtons = $('div.boolean-buttons');

  const initializeBooleanButton = (buttonsDiv) => {
    const $buttonsDiv = $(buttonsDiv);
    const $buttons = $buttonsDiv.find('button');
    $buttons.on('click', (event) => {
      $this = $(event.target);
      let checked = $this.data('value') === true;
      $buttonsDiv.find('input').prop('checked', checked).change();
      $buttons.removeClass('active');
      $this.addClass('active');
    });
  };
  booleanButtons.each((_, buttonsDiv) => initializeBooleanButton(buttonsDiv));
});
